<template>
  <div>
    <label :for="id">Suche</label>
    <input
      :id="id"
      type="search"
      class="form__input"
      :class="color ? `form__input--${color}` : false"
      :value="value"
      @input="$emit('input', $event.target.value)"
    >
  </div>
</template>

<script>
export default {
  name: 'CSearch',

  props: {
    id: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: undefined
    },
    value: {
      type: String,
      default: undefined
    }
  }
}
</script>
